import type { Platform, ScheduledPostDto } from '@reelplicate/api-client/model';
import { BrandMark, type BrandMarkName } from '@reelplicate/ui';
import { Link as RouterLink } from 'react-router';

const MARKS: Record<Platform, BrandMarkName> = {
  TIKTOK: 'tiktok',
  INSTAGRAM: 'instagram',
  YOUTUBE: 'youtube',
  LINKEDIN: 'linkedin',
  FACEBOOK: 'facebook',
};

const NAMES: Record<Platform, string> = {
  TIKTOK: 'TikTok',
  INSTAGRAM: 'Instagram',
  YOUTUBE: 'YouTube',
  LINKEDIN: 'LinkedIn',
  FACEBOOK: 'Facebook',
};

const dayFormat = new Intl.DateTimeFormat(undefined, { weekday: 'short' });
const timeFormat = new Intl.DateTimeFormat(undefined, {
  hour: '2-digit',
  minute: '2-digit',
});

/**
 * Figma "Home / Schedule row" (133:65): a 44px date tile, the title, time and
 * platforms, and each platform's brand mark. Opens the Calendar.
 */
export function ScheduleRow({ post }: { post: ScheduledPostDto }) {
  const at = new Date(post.scheduledAt);
  const platforms = [...new Set(post.accounts.map((account) => account.platform))];
  return (
    <li>
      <RouterLink
        to="/calendar"
        className="focus-visible:shadow-focus-ring hover:bg-bg-subtle -mx-2 flex items-center gap-3 rounded-lg px-2 py-2.5 outline-none"
      >
        <div className="bg-bg-subtle flex size-11 shrink-0 flex-col items-center justify-center rounded-lg">
          <span className="text-overline text-text-secondary uppercase">
            {dayFormat.format(at)}
          </span>
          <span className="text-body-md-strong text-text-primary">{at.getDate()}</span>
        </div>
        <div className="flex min-w-0 flex-1 flex-col gap-0.5">
          <p className="text-body-sm-strong text-text-primary truncate">{post.title}</p>
          <p className="text-caption text-text-secondary">
            {timeFormat.format(at)} · {platforms.map((p) => NAMES[p]).join(', ')}
          </p>
        </div>
        <span className="flex shrink-0 gap-1">
          {platforms.map((platform) => (
            <BrandMark key={platform} name={MARKS[platform]} size={20} />
          ))}
        </span>
      </RouterLink>
    </li>
  );
}
